var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card chart-card" }, [
    _vm.$slots.header
      ? _c("div", { staticClass: "card-header" }, [_vm._t("header")], 2)
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "card-body" }, [
      _c("div", { staticClass: "ct-chart", attrs: { id: _vm.chartId } })
    ]),
    _vm._v(" "),
    _vm.$slots.footer
      ? _c("div", { staticClass: "card-footer" }, [_vm._t("footer")], 2)
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6a01a57c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a01a57c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Cards/ChartCard.vue
// module id = Ks2r
// module chunks = 4